import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/src/locale/pt';

Vue.use(Vuetify, {
  theme: {
    primary: '#BB0D31',
    'primary-dark': '#AA132D',
    'grey-lighten': '#E9E9E9',
  },
  icons: {
    iconfont: 'md',
  },
  breakpoint: {
    thresholds: {
      xs: 770,
      sm: 960,
      md: 1280,
      lg: 1920
    },
    scrollbarWidth: 10
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
});

export default new Vuetify({
});
